import {
  FETCH_TOPICS,
  FETCH_TOPICS_SINGLE,
  FETCH_MEMBER,
  FETCH_MEMBER_SINGLE,
  FETCH_WORKS,
  FETCH_WORKS_SINGLE,
  GET_TOPICS,
  GET_TOPICS_SINGLE,
  GET_MEMBER,
  GET_MEMBER_SINGLE,
  GET_WORKS,
  GET_WORKS_SINGLE
} from '../actions/const';

let config = require('config');

const initialState = {
  topics:null,
  topicsSingle:null,
  member:null,
  memberSingle:null,
  works:null,
  worksSingle:null,
  isScrolled:false
};

module.exports = function(state = initialState, action) {
  switch(action.type) {
    case FETCH_TOPICS: {
      return Object.assign({}, state, {
        topics:null
      })
    } break;
    case FETCH_TOPICS_SINGLE: {
      return Object.assign({}, state, {
        topicsSingle:null
      })
    } break;
    case FETCH_MEMBER: {
      return Object.assign({}, state, {
        member:null
      })
    } break;
    case FETCH_MEMBER_SINGLE: {
      return Object.assign({}, state, {
        memberSingle:null
      })
    } break;
    case FETCH_WORKS: {
      return Object.assign({}, state, {
        works:null
      })
    } break;
    case FETCH_WORKS_SINGLE: {
      return Object.assign({}, state, {
        worksSingle:null
      })
    } break;
    case GET_TOPICS: {
      return Object.assign({}, state, {
        topics:action.body
      })
    } break;
    case GET_TOPICS_SINGLE: {
      return Object.assign({}, state, {
        topicsSingle:action.body
      })
    } break;
    case GET_MEMBER: {
      return Object.assign({}, state, {
        member:action.body
      })
    } break;
    case GET_MEMBER_SINGLE: {
      return Object.assign({}, state, {
        memberSingle:action.body
      })
    } break;
    case GET_WORKS: {
      return Object.assign({}, state, {
        works:action.body
      })
    } break;
    case GET_WORKS_SINGLE: {
      return Object.assign({}, state, {
        worksSingle:action.body
      })
    } break;
    default: {
      return state;
    }
  }
}




// WEBPACK FOOTER //
// ./reducers/data.js